
export default function ObjectKeysLengthFilter() {
    return function (items) {
        if (!items) return 0;
        return Object.keys(items).length;
    };
}
